import { withSvgIcon } from './withSvgIcon';

export const HomeIcon = withSvgIcon(
  <>
    <path
      d="M4 9.55425C4 9.20946 4.17762 8.88899 4.47 8.70625L11.47 4.33125C11.7943 4.12858 12.2057 4.12858 12.53 4.33125L19.53 8.70625C19.8224 8.88899 20 9.20946 20 9.55425V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V9.55425Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M10 15L14 15" stroke="currentColor" strokeWidth="2" />
  </>,
  { viewBox: '0 0 24 24' },
);
